import lodash from 'lodash'; //	lodash 工具库
import Storage from 'store2'; //  本地存储
import {
    Message
} from 'element-ui'; //  消息提示
import {
    axios
} from '@/utils/request'; //  网络请求库
import Store from '@/store/index.js'; //	加载状态管理
import {
    saveAs
} from 'file-saver'; //  导出文件
require('@/utils/Blob'); //  加载Blob.js
import util from "./util.js"; //	工具函数库

import MinCache from './minCache.js'; //	数据本地缓存
const $cache = new MinCache(7200);
const localUserDataKey = 'localUserData'; //	本地用户缓存数据的标识

/**
 * 用户操作类库
 */
export default {

    userData: false, //	登录用户信息

    /**
     * 验证是否登录，如果登录并且在有效期内返回TRUE，否则返回FALSE
     */
    checkLogin() {
        let tokenData = Store.getters['token/getTokenData']; //	使用了vuex的命名空间
        return tokenData.access_token && util.strToTime() < parseInt(tokenData.expired_at) ? true : false;
    },

    /**
     * 获得服务品牌商户ID
     * 注意：默认使用1，1：择珂优选
     * @returns 
     */
    getSbrandId() {
        let sbrandId = '1';
        if (this.checkLogin()) {
            const userData = this.getLoginUserLocalStorage();
            if (userData) {
                sbrandId = userData.user_sbrand_id;
            }
        }
        console.log('sbrandId', sbrandId)
        return sbrandId;
    },

    /**
     * 设置登录用户的本地缓存 
     * @param {Object} userData	用户数据
     */
    setLoginUserLocalStorage(userData) {
        return Storage.set(localUserDataKey, userData);
    },

    /**
     * 获得登录用户本地缓存数据
     */
    getLoginUserLocalStorage() {
        return Storage.get(localUserDataKey);
    },

    /**
     * 删除登录用户本地缓存
     */
    delLoginUserLocalStorage() {
        return Storage.remove(localUserDataKey); //	删除本地缓存
    },

    /**
     * 初始化
     */
    init() {
        //	判断是否已经登录，登录的话就获得登录用户信息
        if (this.checkLogin()) {
            this.getLoginUserData({
                onlyDatabase: true,
                success: (result) => {
                    if (result) {
                        this.userData = result;
                    }
                },
            });
        }
    },

    /**
     * 重新获得用户信息
     */
    reset() {
        this.getLoginUserData({
            onlyDatabase: true,
            success: (result) => {
                if (result) {
                    this.userData = result;
                }
            },
        });
    },

    /**
     * 更新登录用户信息
     * @param {Object} act 		修改类型；
     * 							user_nick_name：修改昵称；
     *                          user_gender：修改性别；
     * 							user_birthday:修改生日
     * 							user_description：修改简介；
     *                          user_sbrand：修改服务品牌商户
     * @param {Object} value 	修改的内容数据
     * @param {Object} option	相关参数
     */
    updateLoginUserData(act, value, option) {
        let defaults = {
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});

        axios.post('/user/edit', {
            'act': act,
            'value': value,
        }, {
            custom: {
                auth: true,
                loading: true,
            }
        }).then(res => {
            if (res.ret == '0') {
                let userData = this.getLoginUserLocalStorage();
                userData[act] = value.toString();
                this.setLoginUserLocalStorage(userData);
                options.success(res);
            } else {
                options.error(res);
            }
        }).catch(err => {

        });
    },

    /**
     * 上传用户图片信息
     * @param {Object} option	相关参数
     */
    uploadUserImage(option) {
        let defaults = {
            custom: {
                auth: true,
                loading: true,
                showToast: true,
            },
            type: 'avatar', //	类别
            name: '', //	文件对应的 key , 开发者在服务器端通过这个 key 可以获取到文件二进制内容
            path: '', //	要上传文件资源的路径。
            formData: { //	额外参数
                'size': '400X400',
            },
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});
        let url = '';
        if (options.type == 'avatar') {
            url = '/user/avatar';
            options.name = 'avatar_images';
        } else if (options.type == 'poster') {
            url = '/user/poster';
            options.name = 'poster_image';
        } else {
            url = '/user/upload-image';
        }
        axios.upload(url, {
            custom: options.custom,
            name: options.name,
            filePath: options.path,
            formData: options.formData,
        }).then(result => {
            if (result.ret == '0') {
                if (options.type == 'avatar' || options.type == 'poster') {
                    let userData = this.getLoginUserLocalStorage();
                    if (options.type == 'avatar') {
                        userData['user_avatar'] = result.data;
                    } else {
                        userData['user_poster'] = result.data;
                    }
                    this.setLoginUserLocalStorage(userData);
                    url = '/user/avatar';
                    options.name = 'avatar_images';
                }
                options.success(result);
            } else {
                options.error(result);
            }
        }).catch(err => {

        });
    },

    /**
     * 获得登录用户信息
     * @param {Object} option	相关参数
     */
    getLoginUserData(option) {
        let defaults = {
            onlyDatabase: false, //	是否直接从服务器上获得；false：先从缓存中获得，如果没有再到服务器上获得；true：直接从服务器上获得
            isSetLocalStorage: true, //	是否保存本地缓存；	true：保存；false：不保存
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});

        let result = {};
        if (!options.onlyDatabase) {
            result = this.getLoginUserLocalStorage();
            //	如果本地有之前的登录用户信息，则先从本地缓存中获得。
            if (result) {
                options.success(result);
                return false;
            }
        }
        axios.post('/user/base', {}, {
            custom: {
                auth: true,
                loading: true,
            }
        }).then(res => {
            if (res.ret == '0') {
                res.data.user_phone_secret = '';
                if (res.data.user_phone) {
                    res.data.user_phone_secret = res.data.user_phone.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
                }
                result = res.data;
                if (options.isSetLocalStorage) {
                    this.setLoginUserLocalStorage(res.data);
                }
                //  将用户购物数量保存到cart的vuex中
                this.addCart({
                    count: res.data.cart_count,
                });

                //  将用户PPT数量保存到ppt的vuex中
                this.addPpt({
                    count: res.data.ppt_count,
                });
                options.success(result);
            } else {
                options.error(result);
            }
        }).catch(err => {

        });
    },

    /**
     * 退出登录
     * @param {Object} option	相关参数
     */
    logout(option) {
        let defaults = {
            clearLocalStorage: true, //	是否清除本地缓存，true:清除；false：不清除
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});
        axios.post('/auth/logout', {}, {
            custom: {
                loading: true,
                showToast: true,
            }
        }).then(res => {
            if (res.ret == '0') {
                Store.dispatch("token/setTokenData", {}); //	清除状态
                if (options.clearLocalStorage) {
                    this.delLoginUserLocalStorage();
                }
                this.delCart(); //  删除购物车信息
                this.delPpt(); //  删除PPT
                options.success(res);
            } else {
                options.error(res);
            }
        }).catch(err => {

        });
    },

    /**
     * 用户导出下载PPT
     * @param {*} option 
     */
    downloadPPT(option) {
        let defaults = {
            postData: {},
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});
        axios.post('/export/ppt', options.postData, {
            custom: {
                auth: true,
                loading: true,
                showToast: true,
            },
        }).then(res => {
            if (res.ret == '0') {
                Message.success('PPT数据装载完成，文件下载中。。。');
                window.location.href = res.data.ppt_file_url;
                options.success(res);
            } else {
                options.error(res);
            }
        });
    },

    /**
     * 用户导出下载PDF
     * @param {*} option 	相关参数
     */
    downloadPDF(option) {
        let defaults = {
            postData: {}, //  请求参数
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});
        axios.post('/export/pdf', options.postData, {
            custom: {
                auth: true,
                loading: true,
                showToast: true,
            },
        }).then(res => {
            if (res.ret == '0') {
                Message.success('PDF数据装载完成，文件下载中。。。');
                //  下载PDF，不预览
                let oReq = new XMLHttpRequest();
                let URLToPDF = res.data.pdf_file_url;
                oReq.open("GET", URLToPDF, true);
                oReq.responseType = "blob";
                oReq.onload = function () {
                    let file = new Blob([oReq.response], {
                        type: 'application/pdf'
                    });
                    saveAs(file, res.data.pdf_name);
                };
                oReq.send();
            }
        });
    },


    /**
     * 根据用户角色来判断导出PPT还是PDF
     * @param {*} option 	相关参数
     */
    downLoadPPTOrPDF(option) {
        let defaults = {
            postData: {}, //  请求参数
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});
        this.getLoginUserData({
            success: (result) => {
                if (result.user_role_id > 1) {
                    this.downloadPPT(options);
                } else {
                    this.downloadPDF(options);
                }
            },
        });
    },

    /**
     * 添加更新购物车信息
     * @param {*} data  购物车信息
     */
    addCart(data) {
        Store.dispatch("cart/setCartData", data); //  存入状态
    },

    /**
     * 获得购物车信息
     */
    getCart() {
        return Store.getters['cart/getCartData']; //	使用了vuex的命名空间
    },

    /**
     * 删除购物车信息
     */
    delCart() {
        Store.dispatch("cart/setCartData", {}); //	清除状态
    },

    /**
     * 获得购物车数量
     * @returns 
     */
    getCartCount() {
        let cartData = Store.getters['cart/getCartData']; //	使用了vuex的命名空间
        return cartData.count ? cartData.count : 0;
    },

    /**
     * 从数据库中获得购物车数据
     */
    getCartCountFromDatabase() {
        axios.post('/cart/count', {}, {
            custom: {
                auth: true,
            },
        }).then(res => {
            if (res.ret == '0') {
                this.addCart({
                    count: res.data.count
                });
            }
        });
    },

    /**
     * 添加更新PPT信息
     * @param {*} data  PPT信息
     */
    addPpt(data) {
        Store.dispatch("ppt/setPptData", data); //  存入状态
    },

    /**
     * 删除购物车信息
     */
    delPpt() {
        Store.dispatch("ppt/setPptData", {}); //	清除状态
    },

    /**
     * 获得PPT数量
     * @returns 
     */
    getPptCount() {
        let pptData = Store.getters['ppt/getPptData']; //	使用了vuex的命名空间
        return pptData.count ? pptData.count : 0;
    },

    /**
     * 发送验证码
     * @param {Object} option	相关参数
     */
    sendSms(option) {
        let defaults = {
            postData: {}, //	提交的数据
            headerConfig: { //	请求头部参数
                custom: {
                    loading: true,
                    showToast: true,
                }
            },
            success: (result) => {}, //  成功函数
            error: (result) => {}, //  失败函数
        };
        let options = Object.assign(defaults, option || {});
        axios.post('/sms/send', options.postData, options.headerConfig).then(res => {
            if (res.ret == '0' || res.ret == '9005') {
                options.success(res);
            } else {
                options.error(res);
            }
        }).catch(err => {

        });
    },

}